export const environment = {
    production: true,
    storageApiRootUrl: "https://api.salescaddy.ai/storage-api",
    adminBuyersCaddyApiRootUrl: "https://api.salescaddy.ai/buyerscaddy-api/admin",
    buyersCaddyApiRootUrl: "https://api.salescaddy.ai/buyerscaddy-api",
    userProfileApiRootUrl:"https://api.salescaddy.ai/user-profile-api",
    meetingApiRootUrl: "https://api.salescaddy.ai/meeting-api/public",
    surveyApiRootUrl: "https://api.salescaddy.ai/survey-api/public",
    searchApiRootUrl: "https://api.salescaddy.ai/search-api",
    pointsApiRootUrl: "https://api.salescaddy.ai/points-api/public",
    contactApiRootUrl: "https://api.salescaddy.ai/contact-api",
    companyApiRootUrl: "https://api.salescaddy.ai/company-api",
    orgchartApiRootUrl: "https://api.salescaddy.ai/orgchart-api",
    connectionsApiRootUrl: "https://api.salescaddy.ai/connections-api",
    userApiRootUrl: "https://api.salescaddy.ai/user-api/public",
    aiProxyApiRootUrl: "https://api.salescaddy.ai/ai-proxy-api/user",
    appName: "Rachel",
    issuerUrl: "https://pawannachnani.us.auth0.com/",
    logoutUrl: "https://buyercaddy.com/",
    clientId: "GPw9TShUzOIPhDviBQqFxAyAeSRxT5Y3",
    categoryScript:'https://api.salescaddy.ai/buyerscaddy-api/public/categories.js?rev=v1',
    scope: 'buyercaddy:user openid email profile offline_access',
    audience: 'https://buyercaddy.com',
    apiDomainName: 'api.salescaddy.ai',
};
